var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "app" } },
    [
      _c("bot-header-menu"),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _c(
            "v-main",
            [
              _c(
                "v-layout",
                { attrs: { "fill-height": "" } },
                [
                  _c("bot-snackbar", {
                    model: {
                      value: _vm.snackbar,
                      callback: function ($$v) {
                        _vm.snackbar = $$v
                      },
                      expression: "snackbar",
                    },
                  }),
                  _c("router-view", { staticClass: "view" }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("bot-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/template.vue